import { List, styled } from "@mui/material";

/**
 * Unordered list, used within table cells.
 */
const CellList = styled(List)({
  listStyleType: 'disc',
  padding: 0,
  paddingLeft: '18px',
  '& .MuiListItem-root': {
    display: 'list-item',
    paddingTop: 0,
    paddingBottom: 0,
  },
});

export default CellList;
